import { ListTimelineModule } from '../partials/layout/quick-sidebar/list-timeline/list-timeline.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { AsideLeftComponent } from './aside/aside-left.component';
import { FooterComponent } from './footer/footer.component';
import { SubheaderComponent } from './subheader/subheader.component';
import { BrandComponent } from './header/brand/brand.component';
import { MenuSectionComponent } from './aside/menu-section/menu-section.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { CoreModule } from '../../core/core.module';
import { UserProfileComponent } from './header/topbar/user-profile/user-profile.component';
import { SearchDropdownComponent } from './header/topbar/search-dropdown/search-dropdown.component';
import { NotificationComponent } from './header/topbar/notification/notification.component';
import { QuickActionComponent } from './header/topbar/quick-action/quick-action.component';
import { BuroGecisComponent } from './header/buro-gecis-menu/buro-gecis-menu.component';
import { GibAktivasyonComponent } from './header/topbar/gib-aktivasyon/gib-aktivasyon.component';
import { AsideRightComponent } from './aside/aside-right/aside-right.component';
import { SearchDefaultComponent } from './header/topbar/search-default/search-default.component';
import { HeaderSearchComponent } from './header/header-search/header-search.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { BuroLisanslamaService } from '@core/services/http_services/genel/buro-lisanslama.service';
import { GibAktivasyonDialogComponent } from './header/topbar/gib-aktivasyon/dialog/gib-aktivasyon-dialog.component';
import { IletisimComponent } from './header/topbar/iletisim/iletisim.component';
import { ETahsilatSistemiComponent } from './header/topbar/e-tahsilat-sistemi/e-tahsilat-sistemi.component';
import { ETahsilatSistemiDialogComponent } from '@pages/components/anasayfa/dialog/e-tahsilat-sistemi-dialog.component';
import { FontSizeChangeComponent } from './header/topbar/font-size-change/font-size-change.component';
import { ArdMaterialModule } from 'src/app/ard-material.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	// suppressScrollX: true
};

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		SubheaderComponent,
		BrandComponent,

		// topbar components
		TopbarComponent,
		UserProfileComponent,
		SearchDropdownComponent,
		NotificationComponent,
		QuickActionComponent,
		IletisimComponent,
		ETahsilatSistemiComponent,
		FontSizeChangeComponent,

		// aside left menu components
		AsideLeftComponent,
		MenuSectionComponent,

		BuroGecisComponent,
		GibAktivasyonComponent,
		GibAktivasyonDialogComponent,
		ETahsilatSistemiDialogComponent,
		// aside right component
		AsideRightComponent,

		SearchDefaultComponent,

		HeaderSearchComponent,

	],
	exports: [
		HeaderComponent,
		FooterComponent,
		SubheaderComponent,
		BrandComponent,

		// topbar components
		TopbarComponent,
		UserProfileComponent,
		SearchDropdownComponent,
		NotificationComponent,
		QuickActionComponent,
		IletisimComponent,
		ETahsilatSistemiComponent,
		FontSizeChangeComponent,

		// aside left menu components
		AsideLeftComponent,
		// MenuSectionComponent,

		BuroGecisComponent,
		GibAktivasyonComponent,
		// aside right component
		AsideRightComponent
	],
	providers: [
		BuroLisanslamaService,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		}
	],
	entryComponents: [
		GibAktivasyonDialogComponent,
		ETahsilatSistemiDialogComponent
	],
	imports: [
		ArdMaterialModule,
		CommonModule,
		RouterModule,
		CoreModule,
		PerfectScrollbarModule,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		ListTimelineModule,
		MatProgressBarModule,
		MatTabsModule,
		MatButtonModule,
		MatTooltipModule,
		TranslateModule.forChild(),
		LoadingBarModule.forRoot(),
		MatMenuModule,
		MatIconModule,
		MatListModule
	]
})
export class LayoutModule { }
